import { ExternalAuthProvider } from '@account/account-portal/external-auth'
import { getTouchpointName } from '@account/account-portal/lib'
import { User } from '@account/account-portal/types'
import { fireUtagLinkEvent } from '@crystal/analytics'

export const trackSocialLoginSuccess = (user: User, provider: ExternalAuthProvider) => {
  const touchPointName = getTouchpointName()
  fireUtagLinkEvent({
    event_category: 'LOGIN',
    event_name: `SOCIAL|${provider}|SUCCESS`,
    customer_email: `${user?.userName}`,
    euci: `${user?.acid ?? ''}`,
    is_new_account: `${user?.session.isNewUser ?? 'FALSE'}`,
    login_location: `${touchPointName ?? 'SOCIAL LOGIN LOCATION NOT SET'}`,
    logged_in: !!user,
    login_remember_me: user.isPersistent,
  })
}
